<template>
  <loading-page v-if="isLoading"></loading-page>
  <div class="orders-container" v-else>
    <base-info :user="user"></base-info>

    <div class="cart-container">
      <h1>My orders</h1>
      <div class="cart">
        <ul>
          <li v-for="order in orders" :key="order._id">
            <ul>
              <li
                v-for="(product, index) in order.products"
                :key="product._id + product.size"
                class="product-info"
              >
                <div class="info-pop-up">
                  <div class="image-container">
                    <img
                      :src="product.image"
                      :alt="product.name"
                      class="product-image"
                    />
                  </div>
                  <div class="text-info">
                    <p class="heading-pop-up">
                      {{ product.name }}
                    </p>
                    <p class="product-price">
                      Price:
                      {{ product.price * (order.quantities[index] || 1) }}$
                    </p>
                    <p class="product-color">
                      Color: {{ getColorName(product.color) }}
                    </p>
                    <p class="product-size">Size: {{ product.size }}</p>
                    <p class="product-quantity">
                      Quantity: {{ order.quantities[index] || 1 }}
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </li>

          <div class="price-info-pop-up">
            <hr />
            <div class="promocode">
              <p class="promocode-text">Promocode</p>
              <p class="promocode-text-value">-</p>
            </div>
            <div class="delivery">
              <p class="delivery-text">Delivery</p>
              <p class="delivery-text-value">20.00$</p>
            </div>
            <hr />
          </div>
          <div class="total-price">
            <p class="total-text">Total:</p>
            <p class="total-text-value">{{ totalPrice }}$</p>
          </div>
        </ul>
      </div>
      <el-collapse class="custom-collapse">
        <el-collapse-item title="About item" name="1">
          <div class="inner-content">
            This item is made from premium-quality materials, ensuring
            long-lasting durability and comfort. Designed with a modern yet
            timeless aesthetic, it's perfect for everyday use or special
            occasions.
          </div>
        </el-collapse-item>
        <el-collapse-item title="Privacy policy" name="2">
          Your privacy is important to us. We collect and process personal
          information only as necessary to provide our services, and we ensure
          that your data is kept secure and confidential. We do not share your
          personal information with third parties without your consent, except
          as required by law. By using our services, you agree to the collection
          and use of your information in accordance with this Privacy Policy.
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import namer from "color-namer";
export default {
  data() {
    return {
      userId: null,
      orders: [],
      isLoading: true,
      user: null,
    };
  },

  created() {
    this.userId = this.$route.params.id;
  },

  computed: {
    totalPrice() {
      return this.orders.reduce((orderSum, order) => {
        const productSum = order.products.reduce((sum, product, index) => {
          const quantity = order.quantities?.[index] || 1;
          return sum + product.price * quantity;
        }, 0);
        return orderSum + productSum;
      }, 0);
    },
  },

  methods: {
    getColorName(hex) {
      if (!hex) return "unknown";
      return namer(hex).html[0].name;
    },
  },

  async mounted() {
    try {
      const res = await fetch(
        `${process.env.VUE_APP_URL}/orders/${this.userId}`
      );
      if (!res.ok) throw new Error("Failed to fetch orders");

      const data = await res.json();

      const allProducts = this.$store.getters.getAllProducts;

      this.orders = data.map((order) => {
        const productsWithSizes = order.productId.map((fullId) => {
          const [productId, size] = fullId.split("_");
          const product = allProducts.find((p) => p._id === productId);

          return {
            ...product,
            size,
          };
        });

        return {
          ...order,
          products: productsWithSizes,
        };
      });

      console.log(this.orders);

      this.user = JSON.parse(localStorage.getItem("user"));

      console.log("user:", this.user);

      this.isLoading = false;

      this.$store.dispatch("checkLoggedIn");
    } catch (error) {
      console.error("Error getting orders", error);
    }
  },
};
</script>

<style scoped>
.orders-container {
  padding: 0 40px 40px 0;
  display: flex;
  gap: 120px;
}
h1 {
  color: #000;
  font-family: "Glusp";
  font-size: 2.4rem;
  font-weight: 700;
  margin-bottom: 30px;
}

.cart {
  margin-bottom: 60px;
}

.container {
  display: flex;
  gap: 15px;
  align-items: flex-end;
}

.order {
  border: 1px solid #000;
}

ul {
  list-style-type: none;
}

.info-pop-up {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.info-pop-up,
.price-info-pop-up,
.total-price {
  max-width: 50rem;
}

.product-image {
  height: 25rem;
}

.text-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
}

.heading-pop-up {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.4rem;
  font-weight: 500;
}

.product-price,
.product-size,
.product-color,
.product-quantity,
.payment-methods p {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2rem;
  font-weight: 300;
}

.promocode,
.delivery {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.promocode {
  margin-top: 12px;
}

.promocode-text,
.delivery-text {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.6rem;
  font-weight: 300;
}

.promocode-text-value {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.6rem;
  font-weight: 300;
}

.delivery-text-value {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.6rem;
  font-weight: 500;
}

.total-price {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.total-text {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.4rem;
  font-weight: 300;
}

.total-text-value {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.2rem;
  font-weight: 500;
}

.custom-collapse {
  max-width: 50rem;
}

.custom-collapse ::v-deep(.el-collapse-item__header) {
  padding: 30px;
  color: #000;
  font-family: "Mabry Pro";
  font-size: clamp(1.3rem, 3vw, 2.4rem);
  font-weight: 500;
  border-radius: 8px 8px 0 0;
}

.custom-collapse ::v-deep(.el-collapse-item__content) {
  padding: 5px 30px 10px 30px;
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.6rem;
  font-weight: 300;
}

.custom-collapse ::v-deep(.el-collapse-item__wrap) {
  border-radius: 0 0 8px 8px;
}

.custom-collapse ::v-deep(.el-collapse-item:not(:last-child)) {
  margin-bottom: 15px;
}

.sidebar {
  width: clamp(20rem, 25rem, 35rem);
  margin-bottom: 15px;
}
.sidebar-list-item:nth-child(1) {
  height: 14rem;
  background: #e5e5e5;
}

.sidebar-list-item:nth-child(2) {
  height: 7.2rem;
  background: #e5e5e5 !important;
}

.sidebar-list-item:nth-child(n + 3) {
  height: 7.2rem;
  background: #fafafa;
}
.sidebar-list-item {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 15px;

  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 10px 20px;
}
.sidebar-list-item {
  font-family: "Mabry Pro";
  color: #000;
  font-size: 1.8rem;
  font-weight: 500;
  justify-content: space-between;
}
.cart-container {
  padding-top: 60px;
}

@media screen and (min-width: 240px) and (max-width: 480px) {
  .orders-container {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    gap: 50px;
    padding: 0 0 30px 0;
  }
  .info-pop-up {
    flex-direction: column;
  }
}

@media screen and (min-width: 481px) and (max-width: 768px) {
  .orders-container {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    gap: 50px;
    padding: 0;
    padding-bottom: 30px;
  }
  .info-pop-up {
    flex-direction: column;
  }
}

@media screen and (min-width: 769px) and (max-width: 1024px) {
}

@media screen and (min-width: 1025px) and (max-width: 1200px) {
}

@media screen and (min-width: 1200px) and (max-width: 1900px) {
}
</style>